export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div
      className="flex flex-wrap items-end justify-between gap-4 border-b border-border pb-4"
      data-testid={testid || "page-header"}
    >
      <div>
        <h1 className="font-display text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
        {subtitle ? <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{subtitle}</p> : null}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function Empty({ label, hint, testid }) {
  return (
    <div className="flex flex-col items-center gap-1 border border-dashed border-border py-14 text-center" data-testid={testid || "empty-state"}>
      <p className="font-display text-base font-bold">{label}</p>
      {hint ? <p className="text-sm text-muted-foreground">{hint}</p> : null}
    </div>
  );
}
